import Cv from './sub-components/Cv';
import { Col, Row } from 'reactstrap';
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
    dataLayer: {
        'event': 'eni_InformationCandidat'
    },
    dataLayerName: 'PageDataLayer'
}
const Candidat = ({ prevStep, nextStep, handleChange, values, civilites, situations, niveauxEtude, handleErreur, CodeTypeJourneeInformation }) => {

    const getCivilite = () => {
        return civilites.map((civilite) => {
            return <option value={civilite.id}>{civilite.libelle}
            </option>;
        });
    }
    const getSituation = () => {
        return situations.map((situation) => {
            return <option value={situation.id}>{situation.libelle}
            </option>;
        });
    }
    const getNiveauEtude = () => {
        return niveauxEtude?.map((niveau) => {
            return <option value={niveau.id}>{niveau.libelle}
            </option>;
        });
    }
    const Continue = e => {
        e.preventDefault();
        nextStep();
    }
    const Previous = e => {
        e.preventDefault();
        prevStep();
    }

    TagManager.dataLayer(tagManagerArgs)
    return (
        <div>
            <h1 className="mb-4 color-magenta-eni spinnaker text-center fs-32 fw-bold">Vos informations</h1>
            <Row className="mb-4" >
                <Col sm="4">
                    <div class="d-flex flex-column">
                        <label className="mb-2">Civilité*</label>
                        <select
                            type="text"
                            value={values.idCivilite}
                            onChange={handleChange('idCivilite')}
                            id="idCivilite"
                        >
                            <option value="0" selected="selected"></option>
                            {getCivilite()}
                        </select>
                        {handleErreur('idCivilite')}
                    </div>
                </Col>
                <Col sm="4" className="mt-sm-0 mt-4">
                    <div class="d-flex flex-column">
                        <label className="mb-2">Nom*</label>
                        <input type="text" id="nom" value={values.nom} onChange={handleChange('nom')} maxLength="80" />
                        {handleErreur('nom')}
                    </div>
                </Col>
                <Col sm="4" className="mt-sm-0 mt-4">
                    <div class=" d-flex flex-column">
                        <label className="mb-2">Prénom*</label>
                        <input type="text" id="prenom" value={values.prenom} onChange={handleChange('prenom')} maxLength="80" />
                        {handleErreur('prenom')}
                    </div>
                </Col>
            </Row>
            <Row className="mb-4">
                <Col sm="4">
                    <div class="d-flex flex-column">
                        <label className="mb-2">Adresse*</label>
                        <input type="text" id="adress" value={values.adress} onChange={handleChange('adress')} maxLength="80" />
                        {handleErreur('adress')}
                    </div>
                </Col>
                <Col sm="4" className="mt-sm-0 mt-4">
                    <div class="d-flex flex-column">
                        <label className="mb-2">Code Postal*</label>
                        <input type="number" id="codepostal" value={values.codepostal} onChange={handleChange('codepostal')} maxLength="5" />
                        {handleErreur('codepostal')}
                    </div>
                </Col>
                <Col sm="4" className="mt-sm-0 mt-4">
                    <div class="d-flex flex-column">
                        <label className="mb-2">Ville*</label>
                        <input type="text" id="ville" value={values.ville} onChange={handleChange('ville')} maxLength="80" />
                        {handleErreur('ville')}
                    </div>
                </Col>
            </Row>
            <Row className="mb-4">
                <Col sm="4">
                    <div class="d-flex flex-column">
                        <label className="mb-2">Date de Naissance*</label>
                        <input type="date" id="naissance" value={values.naissance} onChange={handleChange('naissance')} />
                        {handleErreur('naissance')}
                    </div>
                </Col>
                <Col sm="4" className="mt-sm-0 mt-4">
                    <div class="d-flex flex-column">
                        <label className="mb-2">Téléphone*</label>
                        <input type="text" id="telephone" value={values.telephone} onChange={handleChange('telephone')} maxLength="20" />
                        {handleErreur('telephone')}
                    </div>
                </Col>
                <Col sm="4" className="mt-sm-0 mt-4">
                    <div class="d-flex flex-column">
                        <label className="mb-2">Email*</label>
                        <input type="mail" id="mail" value={values.mail} onChange={handleChange('mail')} maxLength="80" />
                        {handleErreur('mail')}
                    </div>
                </Col>
            </Row>
            <Row className="mb-4">
                <Col sm="4">
                    <div class="d-flex flex-column">
                        <label className="mb-2">Situation*</label>
                        {CodeTypeJourneeInformation === 1 ? (
                            // Affiche la zone de texte si CodeTypeJourneeInformation est 1 
                            <input
                                type="text"
                                value="Etudiant.e"
                                readOnly
                                id="idSituation"
                                class="opacity-50"
                            />
                        ) : (
                            // Sinon, affiche le select avec les options
                            <select
                                type="text"
                                value={values.idSituation}
                                onChange={handleChange('idSituation')}
                                id="idSituation"
                            >
                                <option value="0" selected="selected"></option>
                                {getSituation()}
                            </select>)}
                        {handleErreur('idSituation')}
                    </div>
                </Col>

                {values.idSituation === 121151 && ( // Si la situation est "Etudiant.e"
                    <>
                        <Col sm="4" className="niveauEtudeChoix">
                            <div class="d-flex flex-column ">
                                <label className="mb-2">Quel est votre niveau d'études ?*</label>
                                <select
                                    type="text"
                                    value={values.idNiveauEtude}
                                    onChange={handleChange("idNiveauEtude")}
                                    id="idNiveauEtude"
                                >
                                    <option value="0" selected="selected"></option>
                                    {getNiveauEtude()}
                                </select>
                                {handleErreur('idNiveauEtude')}
                            </div>
                        </Col>
                        <Col sm="4">
                            <div class="margin-checkbox-eni d-flex align-items-center niveauEtudeChoix pt-1">
                                <input type="checkbox" checked={values.etudeInformatique ? "checked" : ""} onChange={handleChange("etudeInformatique")} />
                                <label class="ms-3">Etudes en informatique ?</label>
                            </div>
                        </Col>
                    </>
                )}
                {values.idSituation === 121152 && (// Si la situation est "Salarié.e"
                    <Col sm="4">
                        <div class="margin-checkbox-eni d-flex align-items-center pt-1">
                            <input type="checkbox" checked={values.salarieInformatique ? "checked" : ""} onChange={handleChange("salarieInformatique")} />
                            <label class="ms-3">Salarié&middot;e en informatique ?</label>
                        </div>
                    </Col>
                )}
            </Row>
            <Row className="mb-4">
                <Col sm="8" className="">
                    <div class="mb-2 fw-semibold color-blue-dark-eni spinnaker fs-16">
                        Votre CV
                    </div>
                    <div class="border-outline-eni p-2">
                        <Row className="mb-4">
                            <div class=" d-flex flex-row align-items-center mt-3 height-20">
                                <div class="d-flex flex-row-reverse justify-content-end align-items-center file-upload me-3">
                                    <label class="mx-custom-10" for="displayCv">Je dépose mon CV maintenant</label>
                                    <input type="radio"
                                        checked={values.displayCv ? "checked" : ""}
                                        name="displayCv"
                                        id="updloadCV"
                                        onChange={handleChange('displayCv')} />
                                </div>
                                {values.displayCv && (
                                    <div className="file-upload openSans fw-semibold">
                                        <Cv
                                            values={values}
                                            handleChange={handleChange}
                                            handleErreur={handleErreur}
                                        />
                                    </div>
                                )}
                            </div>
                            <div>
                                {handleErreur('cv')}
                            </div>
                        </Row>
                        <Row>
                            <div class="d-flex flex-row-reverse justify-content-end align-items-center file-upload me-3">
                                <label class="mx-custom-10" for="displayCv">Je préfère envoyer mon CV à la confirmation de mon inscription</label>
                                <input type="radio"
                                    checked={!values.displayCv ? "checked" : ""}
                                    name="displayCv"
                                    id="hideCV"
                                    onChange={(e) => handleChange('displayCv')({ target: { checked: false } })} />
                            </div>
                        </Row>
                    </div>

                </Col>
            </Row>

            <div class="mb-5 mt-4 d-flex justify-content-between">
                <button class="btn-gradient-eni" onClick={Previous}>Précédent</button>
                <button class="btn-gradient-eni" onClick={Continue}>Valider</button>
            </div>
            <span class="color-grey-light-eni fs-12">* Les champs précédés d'un astérisque sont obligatoires</span>
        </div>

    )
}

export default Candidat